import { clsx } from 'clsx';
import React, { useMemo } from 'react';
import { TagGroupContext, TagGroup, TagList } from 'react-aria-components';

const root = "_root_6vpf2_1";
const styles = {
	root: root
};

const FilterChipList = ({ "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, children, className, defaultSelectedKeys, items, onRemove, onSelectionChange, renderEmptyState, selectedKeys, selectionMode, size = "small", style, variant = "primary" }) => {
  const contextValue = useMemo(() => ({
    selectionMode: selectionMode !== null && selectionMode !== void 0 ? selectionMode : void 0,
    size,
    variant
  }), [selectionMode, size, variant]);
  return React.createElement(
    TagGroupContext.Provider,
    { value: contextValue },
    React.createElement(
      TagGroup,
      { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "data-zds": true, defaultSelectedKeys, onRemove, onSelectionChange, selectedKeys, selectionMode },
      React.createElement(TagList, { className: clsx(className, styles.root), "data-zds": true, items, renderEmptyState, style }, children)
    )
  );
};

export { FilterChipList };
//# sourceMappingURL=FilterChipList.es.js.map
